import React from 'react';
import { Box } from '@mui/material';
import { Chart, ChartOption } from '@/components/Base/Chart.tsx';
import { formatLargeNumber } from '@/utils/formatLargNumber';

interface ColumnChartComPorcentagemEvolucaoProps {
  selectedData: {
    valor_meses: {
      nome: string;
      valor: number;
      valor_secundario: number;
      valor_terciario: number;
    }[];
  };
  title: string;
  firstColor: string;
  secondColor: string;
  columnOne: string;
  columnTwo: string;
  percentageName: string;
}

const ColumnChartComPorcentagemEvolucao: React.FC<ColumnChartComPorcentagemEvolucaoProps> = ({ selectedData, title, firstColor, secondColor, columnOne, columnTwo, percentageName }) => {
  if (!selectedData) return null;

  const months = selectedData.valor_meses.map((item) => item.nome);
  const valor1Data = selectedData.valor_meses.map((item) => item.valor);
  // const valor2Data = selectedData.valor_meses.map((item) => item.valor_secundario);
  // const percentualData = selectedData.valor_meses.map((item) => item.valor_terciario);

  const option: ChartOption = {
    title: {
      text: title,
      padding: [
        16,
        5,
        5,
        23,
      ],
      textStyle: {
        fontSize: '14px',
      },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        crossStyle: {
          color: '#999',
        },
      },
      formatter: (params) => {
        const tooltipItems = params.map((item) => {
          const value = item.value;
          const formattedValue = item.seriesName === percentageName ? `${value}%` : value;
          return `<div><strong>${item.seriesName}:</strong> ${formatLargeNumber(formattedValue)}</div>`;
        }).join('');
        return `<div><strong>${params[0].name}</strong></div>${tooltipItems}`;
      },
    },
    legend: {
      data: [columnOne, columnTwo, percentageName],
      right: '0',
      padding: [
        16,
        23,
        5,
        5,
      ],
      textStyle: {
        color: '#000',
      },
      itemStyle: {
        borderColor: '#000',
      },
    },
    grid: {
      left: '3%',
      right: '6%',
      bottom: '3%',
      containLabel: true,
    },
    yAxis: [
      {
        type: 'value',
        name: 'Valor',
        position: 'left',
      },
      {
        type: 'value',
        name: percentageName,
        position: 'right',
        axisLabel: {
          formatter: '{value}%',
        },
      },
    ],
    xAxis: {
      type: 'category',
      data: months,
      axisLabel: {
        interval: 0,
        rotate: 90,
      },
    },
    series: [
      {
        name: columnOne,
        type: 'bar',
        data: valor1Data,
        itemStyle: {
          color: firstColor,
        },
        barWidth: '20%',
        barGap: '10%',
        label: {
          show: true,
          position: 'inside',
          formatter: (params) => formatLargeNumber(Number(params.value)),
          rotate: 90,
          color: '#000',
        },
      },
      // {
      //   name: columnTwo,
      //   type: 'bar',
      //   data: valor2Data,
      //   itemStyle: {
      //     color: secondColor,
      //   },
      //   barWidth: '20%',
      //   barGap: '10%',
      //   label: {
      //     show: true,
      //     position: 'inside',
      //     formatter: (params) => formatLargeNumber(Number(params.value)),
      //     rotate: 90,
      //     color: '#000',
      //   },
      // },
      // {
      //   name: percentageName,
      //   type: 'line',
      //   yAxisIndex: 1,
      //   data: percentualData,
      //   lineStyle: {
      //     color: 'black',
      //     width: 2,
      //   },
      //   smooth: true,
      //   label: {
      //     show: true,
      //     position: 'top',
      //     formatter: '{c}%',
      //     color: '#000',
      //   },
      // },
    ],
  };

  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }} height={'400px'}>
      <Chart option={option} />
    </Box>
  );
};

export default ColumnChartComPorcentagemEvolucao;
